module.exports = __webpack_public_path__ + "static/0041-3096d0a3c7dcd4d292bb84952bf24fc8.png";